var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.06 14.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.06,13.06v.82c0,.24-.2.44-.44.44h-5.58c-.09,0-.17-.04-.22-.11l-1.11-1.59-2.46-3.53c-.11-.15-.33-.15-.44,0l-2.46,3.53-1.11,1.59c-.05.07-.13.11-.22.11H.44c-.24,0-.44-.2-.44-.44v-.82c0-.24.2-.44.44-.44h4.7c.09,0,.17-.04.22-.11l4.45-6.39c.11-.15.33-.15.44,0l4.45,6.39c.05.07.13.11.22.11h4.7c.24,0,.44.2.44.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.4,7.6l-3.15-4.51c-.11-.15-.33-.15-.44,0l-3.15,4.51c-.14.2-.41.25-.61.11l-.68-.47c-.2-.14-.25-.41-.11-.61L9.81.11c.11-.15.33-.15.44,0l4.54,6.51c.14.2.09.47-.11.61l-.68.47c-.2.14-.47.09-.61-.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigmet);
export default __webpack_public_path__ + "static/media/sigmet.a6b6d12e7a29caffbd88ee2f9aebd651.svg";
export { ForwardRef as ReactComponent };